var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHarvestnow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_19_2815)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H28C34.3513 0.5 39.5 5.64873 39.5 12V28C39.5 34.3513 34.3513 39.5 28 39.5H12C5.64873 39.5 0.5 34.3513 0.5 28V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_19_2815)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_2815)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_2815",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 8H8V32H32V8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_2815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3701 12.8891L21.5101 10.2791C20.6501 9.89914 19.3501 9.89914 18.4901 10.2791L12.6302 12.8891C11.1502 13.5491 10.9302 14.4491 10.9302 14.9291C10.9302 15.4091 11.1502 16.3091 12.6302 16.9691L18.4901 19.5791C18.9201 19.7691 19.4601 19.8691 20.0001 19.8691C20.5401 19.8691 21.0801 19.7691 21.5101 19.5791L27.3701 16.9691C28.8501 16.3091 29.0701 15.4091 29.0701 14.9291C29.0701 14.4491 28.8601 13.5491 27.3701 12.8891Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 25.04C19.6203 25.04 19.2403 24.96 18.8903 24.81L12.1503 21.81C11.1203 21.35 10.3203 20.12 10.3203 18.99C10.3203 18.58 10.6503 18.25 11.0603 18.25C11.4703 18.25 11.8003 18.58 11.8003 18.99C11.8003 19.53 12.2503 20.23 12.7503 20.45L19.4903 23.45C19.8103 23.59 20.1803 23.59 20.5003 23.45L27.2403 20.45C27.7403 20.23 28.1903 19.54 28.1903 18.99C28.1903 18.58 28.5203 18.25 28.9303 18.25C29.3403 18.25 29.6703 18.58 29.6703 18.99C29.6703 20.11 28.8703 21.35 27.8403 21.81L21.1003 24.81C20.7603 24.96 20.3803 25.04 20.0003 25.04Z",
    fill: "#34D399"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 30.0009C19.6203 30.0009 19.2403 29.9209 18.8903 29.7709L12.1503 26.7709C11.0403 26.2809 10.3203 25.1709 10.3203 23.9509C10.3203 23.5409 10.6503 23.2109 11.0603 23.2109C11.4703 23.2109 11.8003 23.5409 11.8003 23.9509C11.8003 24.5809 12.1703 25.1509 12.7503 25.4109L19.4903 28.4109C19.8103 28.5509 20.1803 28.5509 20.5003 28.4109L27.2403 25.4109C27.8103 25.1609 28.1903 24.5809 28.1903 23.9509C28.1903 23.5409 28.5203 23.2109 28.9303 23.2109C29.3403 23.2109 29.6703 23.5409 29.6703 23.9509C29.6703 25.1709 28.9503 26.2709 27.8403 26.7709L21.1003 29.7709C20.7603 29.9209 20.3803 30.0009 20.0003 30.0009Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19_2815",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_19_2815",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 34.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_2815"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHarvestnow);
export default __webpack_public_path__ + "static/media/icon-harvestnow.cdd5c225ea86cedd519a9addd658ba24.svg";
export { ForwardRef as ReactComponent };